@if (!selectedCategory) {
  <rt-dropdown class="dropdown">
    <rt-dropdown-header [fullWidthTitle]="true"> {{ header }} </rt-dropdown-header>
    @for (category of categories; track trackByCategoryName($index, category)) {
      <rt-dropdown-item (mousedown)="setCategory(category, $event)" [hasChevronRight]="true">
        <div layout-vertical>
          <rt-heading variant="heading">
            {{ placeholderCategoryTranslationMap[category].name }}
          </rt-heading>
          <span
            [innerHTML]="placeholderCategoryTranslationMap[category].desc"
            class="description info-dropdown-text"
          ></span>
        </div>
      </rt-dropdown-item>
    }
    @for (
      placeholder of noCategoryPlaceholders;
      track trackByPlaceholderName($index, placeholder)
    ) {
      <rt-dropdown-item
        [insertPlaceholder]="placeholder.id"
        [insertPlaceholderTarget]="activeTarget!"
        [isSelected]="placeholder.id === active?.id"
        (click)="select.emit(placeholder)"
        layout-vertical
      >
        <div layout layout-horizontal layout-space-between>
          <div layout layout-vertical>
            <rt-heading variant="heading">
              <span class="preserve-whitespace" margin-right-small-xx text-primary>[ </span>
              {{ withoutBrackets(placeholder.id) }}
              <span class="preserve-whitespace" margin-left-small-xx text-primary> ]</span>
            </rt-heading>
            <span
              [innerHTML]="
                placeholder.interpolated ? placeholder.value : placeholder.data.description
              "
              class="description"
            >
            </span>
          </div>
        </div>
      </rt-dropdown-item>
    }
    @if (selectFooterTemplate) {
      <ng-template [ngTemplateOutlet]="selectFooterTemplate"> </ng-template>
    }
  </rt-dropdown>
}
@if (selectedCategory) {
  <rt-placeholder-select-dropdown
    [placeholders]="placeholders"
    [category]="selectedCategory"
    [activeTarget]="activeTarget!"
    [active]="active"
    [showHeader]="true"
    (back)="setCategory()"
    (select)="setCategory(); select.emit($event)"
  ></rt-placeholder-select-dropdown>
}
